import React from 'react';
import SEO from '../components/SEO';

const Cookies: React.FC = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Cookie Policy',
    description: 'TurboBetto cookie policy and information about how we use cookies',
    url: 'https://turbobetto.com/cookies',
  };

  return (
    <>
      <SEO
        title="Cookie Policy"
        description="Learn about how TurboBetto uses cookies and similar technologies to enhance your browsing experience."
        url="/cookies"
        schema={schema}
      />

      <div className="pt-24 pb-20 min-h-screen bg-dark-bg">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-8">Cookie Policy</h1>
            <p className="text-gray-400 mb-8">Last updated: December 2024</p>

            <div className="space-y-8">
              <section className="bg-dark-card border border-dark-border rounded-xl p-8">
                <h2 className="text-2xl font-bold text-white mb-4">What Are Cookies?</h2>
                <p className="text-gray-300 leading-relaxed">
                  Cookies are small text files that are placed on your device when you visit a
                  website. They are widely used to make websites work more efficiently and provide
                  information to website owners.
                </p>
              </section>

              <section className="bg-dark-card border border-dark-border rounded-xl p-8">
                <h2 className="text-2xl font-bold text-white mb-4">How We Use Cookies</h2>
                <div className="space-y-4 text-gray-300">
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Essential Cookies</h3>
                    <p>
                      These cookies are necessary for the website to function properly. They enable
                      core functionality such as security, network management, and accessibility.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Analytics Cookies</h3>
                    <p>
                      We use analytics cookies to understand how visitors interact with our website.
                      This helps us improve the user experience and optimize our content.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Preference Cookies</h3>
                    <p>
                      These cookies remember your preferences and settings to provide a personalized
                      experience on future visits.
                    </p>
                  </div>
                </div>
              </section>

              <section className="bg-dark-card border border-dark-border rounded-xl p-8">
                <h2 className="text-2xl font-bold text-white mb-4">Third-Party Cookies</h2>
                <p className="text-gray-300 leading-relaxed mb-4">
                  We may use third-party services that set cookies on your device. These include:
                </p>
                <ul className="list-disc list-inside text-gray-300 space-y-2">
                  <li>Google Analytics - for website analytics</li>
                  <li>Social media platforms - for sharing functionality</li>
                  <li>Advertising networks - for relevant advertising (if applicable)</li>
                </ul>
              </section>

              <section className="bg-dark-card border border-dark-border rounded-xl p-8">
                <h2 className="text-2xl font-bold text-white mb-4">Managing Cookies</h2>
                <p className="text-gray-300 leading-relaxed mb-4">
                  You can control and manage cookies in various ways:
                </p>
                <ul className="list-disc list-inside text-gray-300 space-y-2">
                  <li>Browser settings - Most browsers allow you to refuse or accept cookies</li>
                  <li>Cookie consent - Use our cookie consent banner to manage preferences</li>
                  <li>Third-party opt-out - Visit the third-party's website to opt out</li>
                </ul>
                <p className="text-gray-300 leading-relaxed mt-4">
                  Please note that disabling cookies may affect the functionality of our website.
                </p>
              </section>

              <section className="bg-dark-card border border-dark-border rounded-xl p-8">
                <h2 className="text-2xl font-bold text-white mb-4">Cookie Consent</h2>
                <p className="text-gray-300 leading-relaxed">
                  When you first visit our website, you will see a cookie consent banner. You can
                  accept or reject non-essential cookies. Your preferences are saved and you can
                  change them at any time by clearing your browser cookies or contacting us.
                </p>
              </section>

              <section className="bg-dark-card border border-dark-border rounded-xl p-8">
                <h2 className="text-2xl font-bold text-white mb-4">Contact Us</h2>
                <p className="text-gray-300 leading-relaxed">
                  If you have questions about our use of cookies, please contact us at:
                  <br />
                  <a href="mailto:privacy@turbobetto.com" className="text-yellow-400 hover:underline">
                    privacy@turbobetto.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cookies;

